import classNames from 'classnames';
import PropTypes from 'prop-types';
import CTAButton from '../_generic/button/CTAButton';

const VoucherAccordionButton = ({
  children,
  isToggled,
  onClick,
  className,
  disabled,
}) => {
  return (
    <>
      <CTAButton
        className={classNames('accordion-button', className)}
        disabled={disabled}
        isToggled={isToggled}
        onClick={onClick}
      >
        {children}
      </CTAButton>
    </>
  );
};

VoucherAccordionButton.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isToggled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default VoucherAccordionButton;
